export const selectCashup = ($) => $?.cashup ?? null;
export const selectCashupApiData = ($) => $?.cashup?.apiData ?? null;
export const selectCashupIsFetching = ($) => $?.cashup?.isFetching ?? null;
export const selectCashupPriceList = ($) => $?.cashup?.priceList ?? null;
export const selectCashupSoldVouchers = ($) => $?.cashup?.voucherSoldList ?? null;

export const selectCashupResultStylistId = ($) => $?.cashup?.resultStylistId ?? null;
export const selectCashupSelectedStaff = ($) => $?.cashup?.selectedStaff ?? null;
export const selectCashupSelectedStaffName = ($) => $?.cashup?.selectedStaff?.name ?? null;
export const selectCashupSelectedStaffGroup = ($) => $?.cashup?.selectedStaff?.group ?? null;
export const selectCashupSelectedStylistIds = ($) => $?.cashup?.selectedStaff?.selectedStylistIds ?? null;

export const selectCashupDepositLogs = ($) => $?.cashup?.depositApiData?.depositsLogs ?? null;

export const selectCashupVoucherList = ($) => $?.cashup?.voucherList;
